import React from "react";
import { cn } from "src/utils/cn";

const AVATAR_PALETTE = [
  "bg-emerald-500",
  "bg-violet-500",
  "bg-blue-500",
  "bg-amber-500",
  "bg-rose-500",
  "bg-indigo-500",
  "bg-teal-500",
  "bg-orange-500",
];

function getInitials(name) {
  if (!name) return "LZ";
  const parts = name
    .split(" ")
    .map((p) => p.trim())
    .filter(Boolean);
  return parts
    .slice(0, 2)
    .map((p) => p[0])
    .join("")
    .toUpperCase();
}

function getColorClass(id) {
  const index = (id ?? 0) % AVATAR_PALETTE.length;
  return AVATAR_PALETTE[index];
}

/**
 * OrgAvatar
 * Shows the org logo if available, otherwise a colored circle with initials.
 *
 * Props:
 *   org   – organization object { id, name, logo_url? }
 *   size  – "sm" (h-5 w-5) | "md" (h-6 w-6, default) | "lg" (h-8 w-8)
 */
export function OrgAvatar({ org, size = "md" }) {
  const sizeClasses = {
    sm: "h-5 w-5 text-[9px]",
    md: "h-6 w-6 text-[10px]",
    lg: "h-8 w-8 text-[12px]",
  };

  const initials = getInitials(org?.name);
  const colorClass = getColorClass(org?.id);

  return (
    <div
      className={cn(
        "shrink-0 items-center justify-center rounded-full overflow-hidden flex font-bold text-white",
        sizeClasses[size],
        !org?.logo_url && colorClass
      )}
    >
      {org?.logo_url ? (
        <img
          src={org.logo_url}
          alt={org.name}
          className="h-full w-full object-cover"
        />
      ) : (
        initials
      )}
    </div>
  );
}
